import AppShell from "@/components/AppShell";
import { Sparkles, Wand2, Mail, MessageSquare } from "lucide-react";

export default function AIUpdates() {
    return (
        <AppShell breadcrumbs={["AI Updates"]}>
            <div className="max-w-4xl">
                <div className="mb-8">
                    <p className="overline mb-2">AI Updates</p>
                    <h1 className="font-display text-4xl tracking-tight text-slate-900">Client updates, written for you.</h1>
                    <p className="text-slate-500 mt-2 max-w-2xl">
                        Every week, ClientSpace will read what happened in your portals and draft an update in your voice. You review, then send.
                    </p>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-8 mb-4 relative overflow-hidden">
                    <div className="pointer-events-none absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#C55A46]/10 blur-3xl" />
                    <div className="flex items-center gap-3 mb-4 relative">
                        <div className="w-10 h-10 rounded-lg bg-[#FEF2F2] flex items-center justify-center">
                            <Sparkles className="w-4 h-4 text-[#C55A46]" />
                        </div>
                        <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-600">Preview</span>
                    </div>
                    <div className="relative">
                        <p className="text-sm text-slate-400 mb-3">To: marta@northwindcoffee.co · Subject: Week 24 update</p>
                        <div className="prose prose-sm max-w-none text-slate-700 leading-relaxed">
                            <p><span className="text-slate-400">Hey Marta,</span></p>
                            <p>Great week on <strong>Website Redesign</strong>. We finished the second homepage design pass, shipped the initial component library to the portal, and the discovery report is now marked as delivered.</p>
                            <p>One thing needs your input: <strong>Homepage v2</strong> is waiting for your approval — takes about 3 minutes to review from your portal.</p>
                            <p>Next week we're moving into build. Expect the first working preview by Friday.</p>
                            <p className="text-slate-400">— Alessia</p>
                        </div>
                    </div>
                    <div className="mt-6 flex items-center gap-2 relative">
                        <button disabled data-testid="ai-approve-btn" className="btn-terra text-sm font-medium px-4 py-2 rounded-lg opacity-60 cursor-not-allowed">Approve &amp; send</button>
                        <button disabled className="text-sm font-medium border border-slate-200 rounded-lg px-4 py-2 text-slate-500 cursor-not-allowed">Regenerate</button>
                        <span className="ml-auto text-xs text-slate-400">Available soon</span>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-4 stagger">
                    {[
                        { icon: Wand2, t: "Trained on your voice", b: "Point ClientSpace at past emails and it'll match your tone." },
                        { icon: Mail, t: "Scheduled sends", b: "Weekly, biweekly or on-milestone — you decide." },
                        { icon: MessageSquare, t: "Client Q&A", b: "Auto-answers common client questions from portal data." },
                    ].map((f) => (
                        <div key={f.t} className="rounded-xl border border-slate-200 bg-white p-6 hover-lift">
                            <div className="w-9 h-9 rounded-lg bg-slate-50 flex items-center justify-center mb-4"><f.icon className="w-4 h-4 text-slate-500" /></div>
                            <p className="font-display text-lg text-slate-900">{f.t}</p>
                            <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{f.b}</p>
                        </div>
                    ))}
                </div>
            </div>
        </AppShell>
    );
}
